import { render } from "./Sidebar.vue?vue&type=template&id=2c1a5980&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2c1a5980&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=2c1a5980&lang=css"
script.render = render
script.__scopeId = "data-v-2c1a5980"

export default script